<template>
  <div class="news_details_page">
    <div class="news_hero">
      <div class="hero_content">
        <h1 class="news_title animate-fade-in">{{ $t('security.title') }}</h1>
        <div class="news_meta animate-slide-up">
          <span class="meta_item">
            <i class="el-icon-office-building"></i> LPT Technology
          </span>
          <span class="meta_divider">|</span>
          <span class="meta_item">
            <i class="el-icon-date"></i> {{ moment().format('LL') }}
          </span>
        </div>
      </div>
    </div>

    <div class="news_container">
      <div class="article_card">
        <div class="article_body">
          <div class="quote_accent"></div>
          <p v-for="(p, index) in formattedContent" 
             :key="index" 
             class="article_text"
             :class="{ 'first_paragraph': index === 0 }">
            {{ p }}
          </p>
        </div>
        
        <div class="article_footer">
          <router-link to="/news" class="back_btn">
            <i class="el-icon-back"></i> {{ $t('back') || 'Back to News' }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'NewsDetailsFour',
  data() {
    return {
      moment,
    }
  },
  computed: {
    formattedContent() {
      const content = this.$t('security.content');
      return content.split('\n\n');
    }
  }
}
</script>

<style lang="scss" scoped>
.news_details_page {
  background-color: #fcfcfd;
  min-height: 100vh;
}

.news_hero {
  background: linear-gradient(135deg, #6366f1 0%, #358cfc 50%, #009fff 100%);
  padding: 180px 0 140px;
  text-align: center;
  color: white;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -10%;
    left: -10%;
    width: 40%;
    height: 60%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
    filter: blur(60px);
    border-radius: 50%;
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -15%;
    right: -5%;
    width: 50%;
    height: 70%;
    background: radial-gradient(circle, rgba(99, 102, 241, 0.3) 0%, transparent 70%);
    filter: blur(80px);
    border-radius: 50%;
    z-index: 0;
  }
}

.hero_content {
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
  z-index: 2;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.news_title {
  font-size: 3.8rem;
  font-weight: 900;
  line-height: 1.1;
  margin-bottom: 32px;
  letter-spacing: -0.03em;
  background: linear-gradient(to bottom, #ffffff, #f1f5f9);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 768px) {
    font-size: 2.4rem;
  }
}

.news_meta {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  padding: 12px 24px;
  border-radius: 999px;
  width: fit-content;
  margin: 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.2);

  .meta_item {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .meta_divider {
    opacity: 0.3;
  }

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 8px;
    .meta_divider { display: none; }
  }
}

.news_container {
  max-width: 1200px;
  margin: -60px auto 100px;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}

.article_card {
  background: white;
  border-radius: 20px;
  padding: 60px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.08);
  border: 1px solid #f1f5f9;

  @media (max-width: 768px) {
    padding: 30px;
  }
}

.quote_accent {
  width: 40px;
  height: 4px;
  background: #6366f1;
  margin-bottom: 32px;
  border-radius: 2px;
}

.article_text {
  font-size: 1.3rem;
  line-height: 1.9;
  color: #000000;
  margin-bottom: 28px;
  text-align: justify;

  &.first_paragraph {
    font-size: 1.5rem;
    color: #000000;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    font-size: 1.1rem;
    &.first_paragraph { font-size: 1.25rem; }
  }
}

.article_footer {
  margin-top: 60px;
  padding-top: 32px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: center;
}

.back_btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: #f8fafc;
  color: #64748b;
  text-decoration: none;
  border-radius: 999px;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #e2e8f0;

  &:hover {
    background: #6366f1;
    color: white;
    border-color: #6366f1;
    transform: translateX(-4px);
  }
}

// Animations
.animate-fade-in {
  animation: fadeIn 0.8s ease-out forwards;
}

.animate-slide-up {
  animation: slideUp 0.8s ease-out 0.2s forwards;
  opacity: 0;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { 
    opacity: 0;
    transform: translateY(20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
